module.exports = __webpack_public_path__ + "assets/cb9ec9358435fc2a99563755a39d26c7.mp3";